import { Box, Grid2 } from '@mui/material'
import React from 'react'
import i18n from 'simple-react-i18n'
import PropTypes from 'prop-types'
import { CHECKBOX } from 'rpqs/constants/RpqsConstant'
import Checkbox from 'components/forms/Checkbox'
import { NewTable } from 'components/datatable/NewTable'

export const InputTable = ({
    value='',
    onChange=() => {},
    readMode= false,
}) => {
    const val = value || 0
    return (
        <>
            {readMode ?
                <Box
                    sx={{
                        height: '2rem',
                        width: '100px',
                        backgroundColor: 'lightgray',
                        py: 0.5,
                        px: 0.75,
                    }}
                >
                    {val}
                </Box>
                :
                <input
                    style={{ maxWidth: '100px', borderRadius: '2px', margin: 0, height: '2rem' }}
                    value={val}
                    onChange={(e) => onChange(e.target.value)}
                />
            }
        </>
    )
}

InputTable.propTypes = {
    value: PropTypes.number,
    onChange: PropTypes.func,
    readMode: PropTypes.bool,
}

const IndicatorTable = ({
    year='',
    indicators=[],
}) => {
    const previousYear = parseInt(year) - 1

    const input = (indicator) => {
        return indicator.inputType === CHECKBOX ?
            <Checkbox
                checked={indicator[year]?.value}
                onChange={indicator[year]?.onChange}
                readMode={indicator[year]?.readMode}
            /> :
            <InputTable
                value={indicator[year]?.value}
                onChange={indicator[year]?.onChange}
                readMode={indicator[year]?.readMode}
            />
    }

    const headers = [{ key: 'indicator', value: i18n.indicator, width: '10%' }, { key: 'indicatorDenomination', value: i18n.indicatorDenomination, width: '50%' }, { key: 'previousYear', value: previousYear, width: '10%' }, { key: 'year', value: year, width: '10%' }, { key: 'unit', value: i18n.unit, width: '20%' }]

    const formatedIndicators = indicators.map((indi) => {
        const color = indi.resumption ? 'lightGray' : 'black'
        return {
            indicator: <Box sx={{ color }}>{indi.indicator}</Box>,
            indicatorDenomination:
                <Box sx={{ textWrap: 'wrap', color, pr: 1 }}>
                    {`${indi.indicatorDenomination} ${indi.resumption ? `(${i18n.automaticResumption} ${indi.resumption})` : ''}`}
                </Box>,
            previousYear:
                indi.inputType === CHECKBOX ?
                    <Checkbox
                        checked={indi[previousYear]?.value}
                        readMode
                    /> :
                    <Box sx={{ color }}>{indi[previousYear] || 0}</Box>,
            year:
                indi.resumption ?
                    <Box sx={{ py: 1, color }}>{indi[year]?.value || 0}</Box> :
                    <Box sx={{ py: 1, color }}>{input(indi)}</Box>,
            unit: <Box sx={{ color }}>{indi.unit}</Box>,
        }
    })

    return (
        <Grid2 sx={{ '& td': { borderBottom: 'none' } }} size={12}>
            <NewTable
                headers={headers}
                rows={formatedIndicators}
                rowsPerPageOptions={ [1000] } // Remove pagination
            />
        </Grid2>
    )
}

IndicatorTable.propTypes = {
    year: PropTypes.string,
    indicators: PropTypes.arrayOf({
        unit: PropTypes.string,
        indicator: PropTypes.string,
        indicatorDenomination: PropTypes.string,
    }),
}

export default IndicatorTable